<script setup lang="ts">
import { useElementSize } from '@vueuse/core'

const timerWrapperRef = ref<HTMLElement | null>(null)
const { height: timerHeight } = useElementSize(timerWrapperRef)
</script>

<template>
  <div class="relative flex h-screen w-screen overflow-hidden bg-slate-950 text-white">
    <!-- ── Left: Wheel ────────────────────────────────── -->
    <div class="relative flex flex-1 items-center justify-center overflow-hidden p-4">
      <ChallengeWheelSpinWheel/>
      <!-- ── Modal overlay scoped to wheel column ────── -->
      <ChallengeWheelChallengeModal/>
    </div>

    <!-- ── Right: Sidebar ────────────────────────────── -->
    <div class="flex min-w-[200px] w-[22vw] flex-shrink-0 flex-col overflow-y-auto p-4">
      <!--
        Timer lives in normal flow so it reserves its space.
        A mirror spacer of equal height sits below the teams,
        making the teams appear truly centered in the full sidebar
        height when space allows, while guaranteeing the timer
        never overlaps the cards when space is tight.
      -->
      <div ref="timerWrapperRef" class="w-full flex-shrink-0">
        <ChallengeWheelCountdownTimer/>
      </div>

      <!-- Teams: centered in the remaining space -->
      <div class="flex flex-1 items-center">
        <ChallengeWheelTeamScoreboard class="w-full"/>
      </div>

      <!-- Mirror spacer — matches timer height for visual symmetry -->
      <div
        class="flex-shrink-0"
        :style="{ height: `${timerHeight}px` }"
        aria-hidden="true"
      />
    </div>
  </div>
</template>
